"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshMapButton = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const fixedSessionsSlice_1 = require("../../../store/fixedSessionsSlice");
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const mobileSessionsSlice_1 = require("../../../store/mobileSessionsSlice");
const S = __importStar(require("./RefreshMapButton.style"));
const RefreshMapButton = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const handleClick = () => {
        dispatch((0, mobileSessionsSlice_1.clearMobileSessions)());
        dispatch((0, fixedSessionsSlice_1.cleanSessions)());
        dispatch((0, mapSlice_1.setFetchingData)(true));
    };
    return (react_1.default.createElement(S.RefreshButton, { onClick: handleClick }, t("navbar.refreshMap")));
};
exports.RefreshMapButton = RefreshMapButton;
